<template>
    <div class="comment__answer-to do-light-up-selector" @click="highlightComment">
        <div class="comment__answer-to-icon"></div>
        {{comment.user.username}}
    </div>
</template>

<script>
    import {HIGHLIGHT_COMMENT_ACTION} from "VueApps/comments/actions/actions";
    import {scrollToCommentId} from "VueApps/comments/services/scrollToComment";

    export default {
        name: "PointerAnswerTo",
        props: {
            comment: {
                required: true,
                type: Object,
            },
        },
        methods: {
            highlightComment: function () {
                this.$store.dispatch(HIGHLIGHT_COMMENT_ACTION, {
                    commentId: this.comment.id,
                });

                scrollToCommentId(this.comment.id);
            },
        }
    }
</script>

<style scoped>

</style>
